import React, {Component} from 'react';
import {connect} from "react-redux";
import {Alert, Button, Form, Table} from 'react-bootstrap';
import {loadState, saveState} from "../../LocalStore/localStorage";
import {changeStreamUrl, getLiveSchedule} from "../../redux/actions/instructor";
import {Link} from "react-router-dom";
import {changeLiveStatus, getLogin} from "../../redux/actions/auth";
import {home, urlUpdate} from "../../utils/routes";
import LeftMenu from '../home/LeftMenu';


class UrlConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                instructor_id: "",
            },
            userInfo: loadState('userInfo'),
            errors: "",
            success: false
        }
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        await this.props.dispatch(getLiveSchedule(this.state.userInfo.id))

    };

    changeInput = e => {
        const data = {...this.state.data};
        data[e.target.id] = e.target.value;
        this.setState({data});
    };

    submitLogin = async e => {
        e.preventDefault();
        const {instructor_id} = this.state.data;
        const {userInfo, success} = this.state;

        if (instructor_id === "") {
            this.setState({errors: "Stream Url field required!"});
            setTimeout(() => this.setState({errors: ""}), 3000);
        } else {
            await this.props.dispatch(changeStreamUrl(userInfo.instructor_id, instructor_id));
            await this.setState({success: true})
        }
    };

    render() {
        const {userInfo, errors, success} = this.state;
        const {instructor_id} = this.state.data;

        return (
            <div className="mainBody">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-sm-4 col-12 leftMenuContent">
                            <LeftMenu />
                        </div>
                        <div className="col-md-9 col-sm-8 col-12 rightContent">
                            <Form onSubmit={e => this.submitLogin(e)}>
                                {errors && (
                                    <Alert key={1} variant="danger">
                                        {errors}
                                    </Alert>
                                )}

                                {success && (
                                    <Alert key={1} variant="success">
                                        Stream Url Updated !
                                    </Alert>
                                )}
                                <Form.Group controlId="instructor_id">
                                    <Form.Label>Stream URL</Form.Label>
                                    <Form.Control
                                        onChange={this.changeInput}
                                        value={instructor_id || userInfo.stream_url}
                                        type="instructor_id"
                                        className="input"
                                        placeholder="Enter user id"
                                        autoComplete="off"
                                    />
                                </Form.Group>

                                <Form.Group className=" m-t-42 d-flex align-items-center justify-content-between"
                                            style={{marginBottom: "0"}}>
                                    <Button
                                        className="login-btn"
                                        variant="primary"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    InstructorLiveList: state.InstructorLiveList,
    liveStatusChange: state.liveStatusChange
});

export default connect(mapStateToProps)(UrlConfig);
